import type { HeaderNavItem, LocaleOption } from '@VelocitySquared/cady-design-system'
import type { BookingNav } from '@VelocitySquared/sunny16-content-dataobjects-cady/booking'

export interface NavItem {
  label: string
  href: string
}

export const orderPhotosItems: NavItem[] = [
  { label: 'Senior Portraits', href: 'https://store.cady.com/dashboard' },
  { label: 'Underclassmen Photos', href: 'https://store.cady.com/underclass' },
  { label: 'Cap & Gown Images', href: 'https://store.cady.com/capandgown' },
  { label: 'Graduation Ceremony', href: 'https://store.cady.com/graduation' },
  { label: 'Athletic Images', href: 'https://store.cady.com/athletics' }
]

export const navFallback: BookingNav = {
  internalName: '',
  bookSessionLabel: '',
  orderPhotosLabel: '',
  faqLabel: '',
  backLabel: ''
}

export const localeNames: Record<string, string> = {
  en: 'English',
  es: 'Español',
  fr: 'Français'
}

/**
 * Maps the CMS-resolved nav labels + the static Order Photos link list into
 * CadyHeader's navItems shape: one grouping parent ("Order Photos", with
 * orderPhotosItems as its children) and one simple FAQ link. No `active`
 * flags — nothing in cady-booking tracks per-item active/current-section
 * state today.
 */
export function buildNavItems(nav: BookingNav): HeaderNavItem[] {
  return [
    {
      label: nav.orderPhotosLabel,
      children: orderPhotosItems.map((item) => ({
        label: item.label,
        url: item.href,
        newTab: true
      }))
    },
    {
      label: nav.faqLabel,
      url: 'https://cadystudios.zendesk.com/hc/en-us',
      newTab: true
    }
  ]
}

/**
 * Maps supported locale codes into CadyLocaleSwitcher's LocaleOption[].
 * Label format ports the existing optionLabel/localeOptionLabel convention
 * verbatim (e.g. "English (En)") — deliberately not normalized to full
 * uppercase codes, since that would be an unreviewed content change riding
 * along on this component swap.
 */
export function buildLocaleOptions(supportedLocales: string[]): LocaleOption[] {
  return supportedLocales.map((locale) => {
    const name = localeNames[locale] ?? locale
    const code = locale.charAt(0).toUpperCase() + locale.slice(1)
    return { value: locale, label: `${name} (${code})` }
  })
}
